import { db } from '@app/icare/client/db'
import { localCountQueryOptions, localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { jsonObjectFrom } from '@app/icare/db/query/jsonHelpers'
import { CooperationPartnerSchema } from '@app/icare/entities/cooperationPartner/schema/CooperationPartner'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import { zodObjectRootKeys } from '@pkg/api/query'
import dayjs from 'dayjs'

export const patientCooperationPartnerQueries = {
  /** Active relations only, with the joined `to: CooperationPartner` object. Used by the tab bar. */
  forTabs: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCooperationPartner'] } },
      query: db
        .selectFrom('patientCooperationPartner')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('cooperationPartner')
              .select(zodObjectRootKeys(CooperationPartnerSchema, 'cooperationPartner.'))
              .whereRef('cooperationPartner.id', '=', 'patientCooperationPartner.toId'),
          ).as('to'),
        )
        .where(eb => eb.or([eb('activeTo', 'is', null), eb('activeTo', '>=', dayjs().format('YYYY-MM-DD'))]))
        .orderBy('activeFrom', 'asc'),
    }),

  /** Total count of active + inactive relations — used by the tab bar. */
  totalCount: (patientId: PatientIdType) =>
    localCountQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCooperationPartner'] } },
      query: db
        .selectFrom('patientCooperationPartner')
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),

  /** Bare columns, no join, no active filter. Used by the historical index table. */
  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCooperationPartner'] } },
      query: db
        .selectFrom('patientCooperationPartner')
        .select(['id', 'toId', 'activeFrom', 'activeTo', 'deletedAt'])
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),
}
